var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCengage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 308.2 69.2",
    style: {
      enableBackground: "new 0 0 308.2 69.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#003660;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#005B88;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#0098D8;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#00B4EF;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#67CCF2;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#87D5F7;}\n\t.st6{fill:#003660;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st0",
    d: "M15.9,12.6l10.6,3.6l-1.7,8.5l-14.7-5l3.6-6.3C14.3,12.5,15,12.3,15.9,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st1",
    d: "M0.9,39.6l9.3-8.1l7.2,6.3L4.5,49l-4-6.9C-0.1,41.1,0.1,40.3,0.9,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st2",
    d: "M17.5,67.4l-2.7-13.3l10-3.4l3.7,18.5h-8.8C18.5,69.2,17.8,68.6,17.5,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st3",
    d: "M51.7,66.9l-14.2-4.8l2.3-11.4l19.6,6.7l-4.8,8.4C53.9,67,53,67.3,51.7,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st4",
    d: "M69.3,35.3L56.9,46.1l-9.6-8.4l17.1-15l5.3,9.2C70.6,33.2,70.4,34.3,69.3,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st5",
    d: "M49.6,2.5l3.5,17.7l-13.3,4.5L34.9,0.1h11.7C48.4,0.1,49.3,1,49.6,2.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114,51.1c-3.5,1.9-7,2.6-10.2,2.6C93,53.7,86.7,46.3,86.7,36c0-10.2,7.1-18.3,17.8-18.3 c3.8,0,7,0.9,8.8,1.9V24c-2.5-1.3-5.2-2.2-8.7-2.2c-8.1,0-12.9,6.2-12.9,14c0,8.1,4.8,13.8,12.6,13.8c3.3,0,6-1,8.4-2.3L114,51.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M122,18.1h17.7l-1.4,3.9h-11.6v11.3h11.4v3.9h-11.4v12.1h13.2v3.9H122V18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M147.7,18.1h4.6l15.9,20.6c2.1,2.7,3.6,4.8,4.7,6.5h0.1c-0.1-1.9-0.1-3.6-0.1-6.1V18.1h4.7v35.1h-4.2 l-16.4-21.4c-2-2.6-3.4-4.6-4.6-6.3h-0.1c0.1,1.6,0.2,3.4,0.2,5.9v21.9h-4.7V18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M200.9,38.9l-1.4-3.9h14.6v16c-2.6,1.3-7,2.7-11.9,2.7c-10.8,0-17.7-7.3-17.7-17.5 c0-10.7,7.4-18.4,18.5-18.4c4,0,7.5,1,9.7,1.9V24c-2.6-1.3-5.7-2.2-9.5-2.2c-8.8,0-13.8,5.7-13.8,13.9c0,8.5,5.1,13.9,13.1,13.9 c2.7,0,5.2-0.5,6.7-1.3v-9.5H200.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.8,18h3.4l13.6,35.2h-5.1l-3.5-9.2h-13.6l-3.4,9.2h-4.9L232.8,18z M239.8,40l-3.3-9.2 c-1-3-1.5-4.6-2-5.9h-0.1c-0.4,1.3-1,2.9-2,5.9l-3.3,9.1H239.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M268.5,38.9l-1.4-3.9h14.6v16c-2.6,1.3-7,2.7-11.9,2.7c-10.8,0-17.7-7.3-17.7-17.5 c0-10.7,7.4-18.4,18.5-18.4c4,0,7.5,1,9.7,1.9V24c-2.6-1.3-5.7-2.2-9.5-2.2c-8.8,0-13.8,5.7-13.8,13.9c0,8.5,5.1,13.9,13.1,13.9 c2.7,0,5.2-0.5,6.7-1.3v-9.5H268.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M290.2,18.1h17.7l-1.4,3.9h-11.6v11.3h11.4v3.9h-11.4v12.1h13.2v3.9h-17.9V18.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCengage);
export default __webpack_public_path__ + "static/media/cengage.cd7e5b548525cede65539e2ce657a978.svg";
export { ForwardRef as ReactComponent };